import React from 'react';
import ImageEditor from './imageEditor';
import TextEditor from './textEditor';
import './scanner.css'
import './dynamicloader.css'
import { Spin } from "antd";
import {FaTshirt} from 'react-icons/fa'



const antIcon = <FaTshirt size={400} color='rgb(89 216 173)'/>

class ImageArea extends React.Component {
    constructor(props) {
        super(props);
        this.drawingArea = React.createRef();
      }

    componentDidMount(){
        //to ensure that the css is loaded and get the correct width and height
        // setTimeout(() => {
        //     var height=document.getElementById('drawingArea').clientHeight;
        //     var width=document.getElementById('drawingArea').clientWidth;
        //     console.error(height);
        //     if(!document.getElementById("tcanvas"))
        //     {
        //     var canvas=document.createElement("canvas");
        //     canvas.setAttribute("width",width);
        //     canvas.setAttribute("height",height);
        //     canvas.setAttribute("id","tcanvas");
        //     this.drawingArea.current.appendChild(canvas);}

        // }, 500 );

    
    }

    render() { 
        console.error(this.props);
       return (	  
        
        <React.Fragment>

       {/* /* <MobileView>*/ }
        {/* <div id="shirtDiv"   className="page" style={{width:"250px",height:"300px",position:"relative",backgroundColor:"grey"}}>
         <img id="tshirtFacing" alt="https://user-images.githubusercontent.com/24848110/33519396-7e56363c-d79d-11e7-969b-09782f5ccbab.png" style={{height:"305px"}} src="/Assets/img/crew_front.png"></img>
        <div id="drawingArea" style={{background:"black" ,position:"absolute",top:"39px",left:"49px",zIndex:"10",width:"84px",height:"225px"}}>					
            <canvas id="tcanvas" width="200" height="400" className="hover" ></canvas>
        </div>
        </div> */}
        {/*<div id="shirtDiv"   className="page" >
         <img id="tshirtFacing" alt="https://user-images.githubusercontent.com/24848110/33519396-7e56363c-d79d-11e7-969b-09782f5ccbab.png" src="/Assets/img/crew_front.png"></img>
        <div id="drawingArea" ref={this.drawingArea}>					
        </div>
        </div>
    </MobileView>*/}
        {/* <BrowserView> */}
        {/* <Spin tip="Preparing Your Shirt... This Might Take up to 30 seconds..." spinning={this.props.props.designer.loader} size='large' style={{height:'200px',color:'rgb(89 216 173)'}} indicator={antIcon}> */}
        <div style={{display:'none',textAlign:'center'}} id='Loader' className="wrap">
		<div className="prog-bar">
        </div>
	</div>
         <div id="shirtDiv" style={{backgroundColor:this.props.props.designer.selectedShirtColor,border:'none'}}>
         <span id='scanner' style={{display:'none'}}></span>
         {this.props.props.designer.showFrontView?(            <img
         crossOrigin='anonymous'
              id="tshirtFacing"
              alt="https://user-images.githubusercontent.com/24848110/33519396-7e56363c-d79d-11e7-969b-09782f5ccbab.png"
              src={this.props.props.designer.selectedShirtType.frontImageUrl}
              style={{height:"100%",width:"100%"}}
            ></img>):(            <img
                id="tshirtFacing"
                alt="https://user-images.githubusercontent.com/24848110/33519396-7e56363c-d79d-11e7-969b-09782f5ccbab.png"
                src={this.props.props.designer.selectedShirtType.backImageUrl}
                style={{height:"100%",width:"100%"}}
              ></img>)}
         {/* <img id="tshirtFacing" alt="https://user-images.githubusercontent.com/24848110/33519396-7e56363c-d79d-11e7-969b-09782f5ccbab.png" style={{height:"100%",width:"100%"}}  src={this.props.props.props.designer.selectedShirtType.frontImageUrl}></img> */}

        <div id="drawingArea" ref={this.drawingArea}>					
            {/* <canvas id="tcanvas" width="200" height="400" className="hover" ></canvas> */}
        </div>

        </div>
        <div style={{display:'none'}} id="confirmBtn" className="checkout_button trans_100">
                    <button id="submitBtn" onClick={()=>{document.getElementById("submitFormDiv").scrollIntoView({ behavior: "smooth" });}}>
                      Confirm
                    </button>
                  </div>
        {/* </Spin> */}
        {/* </BrowserView> */}
        </React.Fragment>  
    //     <div id="shirtDiv"   className="page" style={{width:"100%",height:"100%",position:"relative",backgroundColor:"white"}}>
    //     <img id="tshirtFacing" alt="https://user-images.githubusercontent.com/24848110/33519396-7e56363c-d79d-11e7-969b-09782f5ccbab.png" src="/Assets/img/crew_front.png"></img>
    //    <div id="drawingArea"style={{width:"100%",height:"100%",margin:0}} >
           
			
    //        <canvas id="tcanvas" width="90" height="182" className="hover" ></canvas>
    //    </div>
    //    </div>
          );
    }
}
 
export default ImageArea;

// const ImageArea = (props) => {
//     //const deviceWidth=Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
//     //const ownProps=props.props;
//     return (	  
//         <React.Fragment>
//         <MobileView>
//         {/* <div id="shirtDiv"   className="page" style={{width:"250px",height:"300px",position:"relative",backgroundColor:"grey"}}>
//          <img id="tshirtFacing" alt="https://user-images.githubusercontent.com/24848110/33519396-7e56363c-d79d-11e7-969b-09782f5ccbab.png" style={{height:"305px"}} src="/Assets/img/crew_front.png"></img>
//         <div id="drawingArea" style={{background:"black" ,position:"absolute",top:"39px",left:"49px",zIndex:"10",width:"84px",height:"225px"}}>					
//             <canvas id="tcanvas" width="200" height="400" className="hover" ></canvas>
//         </div>
//         </div> */}
//         <div id="shirtDiv"   className="page" >
//          <img id="tshirtFacing" alt="https://user-images.githubusercontent.com/24848110/33519396-7e56363c-d79d-11e7-969b-09782f5ccbab.png" src="/Assets/img/crew_front.png"></img>
//         <div id="drawingArea">					
//         </div>
//         </div>
//         </MobileView>
//         <BrowserView>
//          <div id="shirtDiv"   className="page" style={{width:"500px",height:"600px",position:"relative",backgroundColor:"grey"}}>
//          <img id="tshirtFacing" alt="https://user-images.githubusercontent.com/24848110/33519396-7e56363c-d79d-11e7-969b-09782f5ccbab.png" style={{height:"605px"}} src="/Assets/img/crew_front.png"></img>
//         <div id="drawingArea" style={{position:"absolute",top:"100px",left:"145px",zIndex:"10",width:"200px",height:"400px"}}>					
//             <canvas id="tcanvas" width="200" height="400" className="hover" ></canvas>
//         </div>
//         </div>
//         </BrowserView>
//         </React.Fragment>  
//     //     <div id="shirtDiv"   className="page" style={{width:"100%",height:"100%",position:"relative",backgroundColor:"white"}}>
//     //     <img id="tshirtFacing" alt="https://user-images.githubusercontent.com/24848110/33519396-7e56363c-d79d-11e7-969b-09782f5ccbab.png" src="/Assets/img/crew_front.png"></img>
//     //    <div id="drawingArea"style={{width:"100%",height:"100%",margin:0}} >
           
			
//     //        <canvas id="tcanvas" width="90" height="182" className="hover" ></canvas>
//     //    </div>
//     //    </div>
//           );
// }
 
// export default ImageArea;